import { IBudgetConstruction } from '@apply/api/src/api/ApplyApi';
import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetConstructionField } from '../../../../../queries/useBudgetConstructionField';

interface DemolitionProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Demolition: React.FC<DemolitionProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [demolition, set_demolition] = useBudgetConstructionField<number>(
        propertyGuid,
        (b) => b.values?.['Site Work']?.['Demolition'] ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Site Work': { ...b.values?.['Site Work'], 'Demolition': v } } })
    );
    const label = 'Demolition';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(demolition)}
                />
            ) : (
                <MoneyBox
                    id={'demolition'}
                    allowNegative={false}
                    value={demolition}
                    onChange={(value) => set_demolition(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
